export default "__VITE_ASSET__0c0e52e8__"